import Cookies from 'js-cookie';
import apiSlice from './apiSlice';

const apiSliceWithTag = apiSlice.enhanceEndpoints({ addTagTypes: ['community'] });

const fetchOrganizationsBrand = apiSliceWithTag.injectEndpoints({
  endpoints: (builder) => ({
    getOrganizationBrand: builder.query({
      query: ({ opk, ordering, page, psize }) => ({
        url: `/community/organizations/${opk}/brands/`,
        method: 'GET',
        params: {
          ordering,
          page,
          psize,
        },
      }),
      providesTags: ['community'],
    }),
    createOrganizationBrand: builder.mutation({
      query: ({ opk, payload }) => ({
        url: `/community/organizations/${opk}/brands/`,
        method: 'POST',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['community'],
    }),
    patchOrganizationBrand: builder.mutation({
      query: ({ opk, id, payload }) => ({
        url: `/community/organizations/${opk}/brands/${id}`,
        method: 'PATCH',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['community'],
    }),
    destroyOrganizationBrand: builder.mutation({
      query: ({ opk, id }) => ({
        url: `/community/organizations/${opk}/brands/${id}`,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['community'],
    }),
    getOneOrganizationBrand: builder.query({
      query: ({ opk, id }) => ({
        url: `/community/organizations/${opk}/brands/${id}`,
        method: 'GET',
      }),
      providesTags: ['community'],
    }),
    editOneOrganizationBrand: builder.mutation({
      query: ({ opk, id, payload }) => ({
        url: `/community/organizations/${opk}/brands/${id}`,
        method: 'PUT',
        body: payload,
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Cookies.get('csrftoken'),
        },
      }),
      invalidatesTags: ['community'],
    }),
  }),
});

export const { useCreateOrganizationBrandMutation, useDestroyOrganizationBrandMutation, useGetOrganizationBrandQuery, useGetOneOrganizationBrandQuery, useEditOneOrganizationBrandMutation, usePatchOrganizationBrandMutation } = fetchOrganizationsBrand;

export default fetchOrganizationsBrand;
